import { makeStyles } from "@material-ui/styles";

export default makeStyles({
  full: {
    height: "100%",
    width: "100%",
  },
});
